//==========import components===============
import ContactForm from 'components/contact-us/ContactForm';
import ContactMap from 'components/contact-us/ContactMap';
import SubPagesLayout from 'layouts/SubPagesLayout';

const ContactUsPage = () => {
  return (
    <div className='DBlock contactUsPage'>
      <ContactForm />
      <ContactMap />
    </div>
  );
};

export default SubPagesLayout({ route: 'Home/contact us' })(ContactUsPage);
